export const selectCartEvent = (state) => state.data.cart.event;
export const selectCartTickets = (state) => state.data.cart.tickets;
export const selectCartSeats = (state) => state.data.cart.seats;
export const selectCartCurrency = (state) => state.data.cart.currency;
export const selectCartTotal = (state) => state.data.cart.total;
export const selectCartWaitingPayment = (state) => state.data.cart.waitingPayment;
export const selectCartFormData = (state, form) => state.data.cart.forms[form];
export const selectCartRemainingTime = (state) => state.data.cart.remainingTime;
export const selectCartContactDetails = (state) => state.data.cart.contactDetails;
export const selectPhoneContactDetails = (state) => state.data.cart.contactDetails.phone;
